import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeft, ArrowRight, BoxIcon } from 'lucide-react';
interface Persona {
  icon: BoxIcon;
  title: string;
  text: string;
}
interface SubpageCTAProps {
  badgeText: string;
  badgeColor?: 'terracotta' | 'sage';
  heading: string;
  subheading: string;
  personas: Persona[];
  ctaText?: string;
  ctaSubtext?: string;
  backLinkText?: string;
  backLinkUrl?: string;
}
export function SubpageCTA({
  badgeText,
  badgeColor = 'terracotta',
  heading,
  subheading,
  personas,
  ctaText = 'Skriv ett mail — så hör jag av mig inom ett par dagar.',
  ctaSubtext = 'Inga säljpitchar. Bara ett ärligt samtal.',
  backLinkText = 'Tillbaka till startsidan',
  backLinkUrl = '/'
}: SubpageCTAProps) {
  const badgeBgClass = badgeColor === 'terracotta' ? 'bg-terracotta/10' : 'bg-sage/10';
  const badgeTextClass = badgeColor === 'terracotta' ? 'text-terracotta' : 'text-sage';
  const iconBgClass = badgeColor === 'terracotta' ? 'bg-terracotta/10' : 'bg-sage/10';
  const iconColorClass = badgeColor === 'terracotta' ? 'text-terracotta' : 'text-sage';
  return <section className="py-20 md:py-28 px-6 bg-background" data-id="element-214">
      <div className="max-w-2xl mx-auto text-center" data-id="element-215">
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-card rounded-3xl p-10 md:p-16 border border-border/50 shadow-sm" data-id="element-216">
          <div className="flex items-center justify-center gap-2 mb-8" data-id="element-217">
            <span className={`${badgeBgClass} ${badgeTextClass} text-xs font-medium tracking-widest uppercase px-3 py-1.5 rounded-full`} data-id="element-218">
              {badgeText}
            </span>
          </div>

          <h2 className="text-3xl md:text-4xl font-light text-ink mb-3" data-id="element-219">
            {heading}
          </h2>
          <p className="text-muted text-sm leading-relaxed mb-8 max-w-sm mx-auto" data-id="element-220">
            {subheading}
          </p>

          {/* Persona recognition cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-10 text-left" data-id="element-221">
            {personas.map((persona, i) => <div key={i} className="flex items-start gap-3 rounded-xl p-4 border border-border/40 bg-background/60" data-id="element-222">
                <div className={`w-8 h-8 rounded-full ${iconBgClass} flex items-center justify-center flex-shrink-0`} data-id="element-223">
                  <persona.icon className={`w-3.5 h-3.5 ${iconColorClass}`} strokeWidth={1.5} data-id="element-224" />
                </div>
                <div className="flex-1 min-w-0" data-id="element-225">
                  <p className="text-sm font-medium text-ink" data-id="element-226">
                    {persona.title}
                  </p>
                  <p className="text-xs text-muted leading-relaxed mt-0.5" data-id="element-227">
                    {persona.text}
                  </p>
                </div>
              </div>)}
          </div>

          <div className="w-8 h-px bg-border mx-auto mb-8" data-id="element-228" />

          <p className="text-muted text-lg leading-relaxed mb-3" data-id="element-229">{ctaText}</p>
          <p className="text-muted text-sm italic mb-10" data-id="element-230">{ctaSubtext}</p>

          <a href="mailto:peter@humble-consulting.se" className="inline-flex items-center gap-2 bg-terracotta hover:bg-terracotta/90 text-white px-8 py-4 rounded-full text-lg font-medium transition-all duration-200 hover:scale-105 shadow-lg shadow-terracotta/20" data-id="element-231">
            Boka ett samtal
            <ArrowRight className="w-5 h-5" data-id="element-232" />
          </a>

          <div className="mt-8" data-id="element-233">
            <Link to={backLinkUrl} className="text-muted hover:text-ink transition-colors text-sm flex items-center justify-center gap-2 group" data-id="element-234">
              <ArrowLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform" data-id="element-235" />
              {backLinkText}
            </Link>
          </div>
        </motion.div>
      </div>
    </section>;
}